import gradients from '../Gradients/gradientPallet';
import { useLinearGradient, useRadialGradient } from '../Gradients/useGradient';
import useFigure from '../useFigure';
import { strokeWidth } from '../constants';

const Measure = ({ qubits }) => {
  const {
    x, y,
  } = qubits.rect.center;

  const { mx, my } = qubits.measure;

  const Circle = useFigure('circle');
  const Line = useFigure('line');
  const Arrow = useFigure('arrow');
  const Rect = useFigure('roundRect');
  const Arc = useFigure('arc');

  const backGround = 'rgba(6, 14, 31, 1)';
  const { gradient4: gradient } = gradients;

  const { startColor, endColor, scale } = gradient.fill;

  const {
    x: x1, y: y1, width, height,
  } = qubits.rect;
  const grd = useRadialGradient({
    startColor, endColor, width, scale, x: x1, y: y1,
  });
  const { startColor: firstColor, endColor: lastColor } = gradient.stroke;

  const stroke = useLinearGradient({
    x1, y1, x2: x1 + width, y2: y1 + height, firstColor, lastColor,
  });

  Arrow({
    x1: x, y1: y, x2: x, y2: my, stroke, strokeWidth, strokeDashArray: [5, 5],
  });

  Rect({
    ...qubits.rect, fill: grd, stroke, strokeWidth, radii: [8], backGround,
  });

  Circle({
    cx: x, cy: y, r: width / 20, stroke: 'white',
  });
  const delta = Math.PI / 6;
  const r = width / 3;

  Arc({
    cx: x, cy: y, r, stroke: 'white', strokeWidth, startAngle: Math.PI - delta, endAngle: 0 + delta, direction: true,
  });

  Line({
    x1: x, y1: y, x2: x + r / 2, y2: y + -r / 2, stroke: 'white', strokeWidth,
  });
};

export default Measure;
